import React from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import SelectMediaModel from '../../Campaign/CampainComps/SelectMediaModel';



const SendTemplatePreview = ({
    templateCategory,
    template,
    mediaType,
    showMediaModel,
    mediaLink,
    buttonStyle,
    mediaName,
    setMediaLink,
    templateInputs,
    templateUrlInputs, // New prop for handling URL inputs
    openMediaModel,
    handleCancelMediaModel,
    HandleUploadImage,
    location,
    setLocation,
}) => {
    // useEffect(() => {
    //     if (templateInputs) {
    //     console.log('Template Inputs:', templateInputs);
    //     }
    // }, [templateInputs]);
    return (
        <>
            <SelectMediaModel
                openMediaModel={openMediaModel}
                handleCancelMediaModel={handleCancelMediaModel}
                HandleUploadImage={HandleUploadImage}
                requestType={'template'}
            />
            <Form layout="vertical">
                {templateCategory &&
                    <>
                        {template?.header && template?.header?.format !== 'TEXT' && (
                            <>
                                {template?.header?.format === 'LOCATION' ? (
                                    <Row gutter={ROW_GUTTER}>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Latitude"
                                                name="location-latitude"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter latitude!',
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    type="number"
                                                    step="any"
                                                    placeholder="e.g., 37.7749"
                                                    value={location?.latitude}
                                                    onChange={(e) =>
                                                        setLocation({ ...location, latitude: e.target.value })
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Longitude"
                                                name="location-longitude"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter longitude!',
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    type="number"
                                                    step="any"
                                                    placeholder="e.g., -122.4194"
                                                    value={location?.longitude}
                                                    onChange={(e) =>
                                                        setLocation({ ...location, longitude: e.target.value })
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Location Name (Optional)"
                                                name="location-name"
                                            >
                                                <Input
                                                    type="text"
                                                    placeholder="e.g., Our Office"
                                                    value={location?.name}
                                                    onChange={(e) =>
                                                        setLocation({ ...location, name: e.target.value })
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="Address (Optional)" name="location-address">
                                                <Input.TextArea
                                                    placeholder="123 Main St"
                                                    autoSize={{ minRows: 1, maxRows: 4 }}
                                                    value={location?.address}
                                                    onChange={(e) =>
                                                        setLocation({ ...location, address: e.target.value })
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                ) : (
                                    <>
                                        {mediaType === 'Media' ? (
                                            <Form.Item label="Select media" name="media-link">
                                                {!mediaLink ? (
                                                    <Button
                                                        type=""
                                                        style={buttonStyle}
                                                        onClick={showMediaModel}
                                                    >
                                                        <CloudUploadOutlined />
                                                        Choose File
                                                    </Button>
                                                ) : (
                                                    <>
                                                        <Input
                                                            type="text"
                                                            disabled
                                                            value="Media Selected"
                                                            className="mb-3"
                                                        />
                                                        <Button
                                                            type=""
                                                            style={buttonStyle}
                                                            onClick={showMediaModel}
                                                        >
                                                            <CloudUploadOutlined />
                                                            Choose Another File
                                                        </Button>
                                                        <p className="d-none">{mediaName}</p>
                                                    </>
                                                )}
                                            </Form.Item>
                                        ) : (
                                            <Form.Item
                                                label="Your media file link"
                                                name="media-link"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter campaign name!',
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    type="text"
                                                    onChange={(e) => setMediaLink(e.target.value)}
                                                    className="mb-3"
                                                />
                                            </Form.Item>
                                        )}
                                    </>
                                )}
                            </>
                        )}

                        <div>
                            {templateInputs?.length > 0 && (
                                <Form.Item
                                    label={`${templateInputs?.length} dynamic values detected`}
                                >
                                    <Row gutter={ROW_GUTTER}>
                                        {templateInputs?.map((input, index) => (
                                            <Col span={8} key={index} className="mb-2">
                                                {input}
                                            </Col>
                                        ))}
                                    </Row>
                                </Form.Item>
                            )}
                        </div>          {/* Handling templateUrlInputs */}
                        <div>
                            {templateUrlInputs.length > 0 && (
                                <Form.Item label={`${templateUrlInputs.length} Url Button detected`}>
                                    {templateUrlInputs?.map((input, index) => (
                                        <div key={index} className="mb-2">
                                            {input}
                                        </div>
                                    ))}
                                </Form.Item>
                            )}
                        </div>
                    </>
                }
            </Form>
        </>
    );
};

export default SendTemplatePreview;
